import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import {
  DispersionListQuery,
  DispersionRepository,
} from '@app/domain/ports/tpv/dispersion.repository';
import { TpvDispersion } from '@app/domain/models/tpv/dispersion.model';
import { TpvPage } from '@app/domain/models/tpv/tpv-page.model';

/** Mock de dispersiones para pruebas sin backend (tpvUseMocks). */
@Injectable()
export class DispersionMockDataSource extends DispersionRepository {
  override getDispersions(
    externalIdMerchant?: string,
    query: DispersionListQuery = {},
  ): Observable<TpvPage<TpvDispersion>> {
    // Sin comercio → devolvemos el mismo set con un UUID sintético (mock del scope
    // "todas las dispersiones del usuario" que expone el backend real).
    const merchantId = externalIdMerchant ?? '019e8a80-0000-0000-0000-000000000000';
    const dispersions: TpvDispersion[] = [
      { idDispersion: 1, externalIdMerchant: merchantId, companyName: 'Empresa Demo SA de CV', unitName: 'UN Centro', merchantName: 'Comercio Demo 1', processor: 'Prosa', date: '2026-06-01', receivedMerchantAmount: 1250.5, status: 'completed' },
      { idDispersion: 2, externalIdMerchant: merchantId, companyName: 'Empresa Demo SA de CV', unitName: 'UN Norte', merchantName: 'Comercio Demo 2', processor: 'Banorte', date: '2026-06-02', receivedMerchantAmount: 980.0, status: 'pending' },
      { idDispersion: 3, externalIdMerchant: merchantId, companyName: 'Empresa Demo SA de CV', unitName: 'UN Sur', merchantName: 'Comercio Demo 3', processor: 'Prosa', date: '2026-06-03', receivedMerchantAmount: 3420.75, status: 'completed' },
    ];
    return of({
      data: dispersions,
      total: dispersions.length,
      page: query.page ?? 1,
      limit: query.limit ?? 10,
    }).pipe(delay(300));
  }

  override getDispersionById(
    idDispersion: string | number,
  ): Observable<TpvDispersion | null> {
    const id = Number(idDispersion) || 1;
    return of<TpvDispersion>({
      idDispersion: id,
      externalIdMerchant: '019e8a80-0000-0000-0000-000000000000',
      companyName: 'Empresa Demo SA de CV',
      unitName: 'UN Centro',
      merchantName: 'Comercio Demo',
      processor: 'Prosa',
      date: '2026-06-01',
      receivedMerchantAmount: 1250.5,
      status: 'completed',
    }).pipe(delay(300));
  }
}
